<div class="confirm-dialog">
    <h2 class="dialog-title">{{ data.title | translate }}</h2>
    <p class="dialog-message">{{ data.message | translate }}</p>
    <div class="dialog-actions">
        <button type="button" class="btn-cancel" (click)="onCancel()">
            {{ (data.cancelLabel || 'cancel') | translate }}
        </button>
        <button type="button" class="btn-confirm" (click)="onConfirm()">
            {{ (data.confirmLabel || 'confirm') | translate }}
        </button>
    </div>
</div>
